import { inject, Injectable } from "@angular/core";
import { MatPaginatorIntl } from "@angular/material/paginator";
import { TranslateService } from "@ngx-translate/core";

@Injectable()
export class PaginatorIntlService extends MatPaginatorIntl {
  override itemsPerPageLabel = "Items per page:";
  override nextPageLabel = "Next";
  override previousPageLabel = "Previous";
  override firstPageLabel = "First";
  override lastPageLabel = "Last";

  private translate = inject(TranslateService);

  constructor() {
    super();
    this.translateLabels();
  }

  getRangeLabel = function (page: number, pageSize: number, length: number) {
    if (length === 0 || pageSize === 0) {
      return "0 " + this.translate.instant("Paginator.Of") + " " + length;
    }
    const startIndex = page * pageSize;
    const endIndex = Math.min(startIndex + pageSize, length);
    return startIndex + 1 + " - " + endIndex + " " + this.translate.instant("Paginator.Of") + " " + length;
  };

  translateLabels() {
    this.itemsPerPageLabel = this.translate.instant("Paginator.ItemsPerPage");
    this.nextPageLabel = this.translate.instant("Paginator.NextPage");
    this.previousPageLabel = this.translate.instant("Paginator.PreviousPage");
    this.firstPageLabel = this.translate.instant("Paginator.FirstPage");
    this.lastPageLabel = this.translate.instant("Paginator.LastPage");
    this.changes.next();
  }
}
